import { RightOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  Radio,
  Space,
  Spin,
  Table,
  Divider
} from "antd";
// import { Space, Table, Drawer , Button, Tag } from 'antd';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import accountService from "../../../api/account.service";

import ProgrammeCommercialService from "../../../api/programme.commercial.service";
import ProgrammeService from "../../../api/programme.service";
import { addProgrammeCommercial } from "../../../store/programmeCommercialSlice";

//import ProgrammeCommercialService from "../../../api/programme.commercial.service";

import {
  EDIT_MODE,
  GYM_PROGRAM_ID,
  HP_PROGRAM_ID,
  JHP_PROGRAM_ID,
  SUCCESS_STATUS,
} from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";

import CustomMessage from "../../common/CustomMessage";
const { Option } = Select;

const ProgrammComercialEntry = ({ data, onDrawerClose }) => {
  // console.log(data)
  const dispatch = useDispatch();

  const [isLoaderEnable, setIsLoaderEnable] = useState(false);
  const [isMonthlyGenerate, setIsMonthlyGenerate] = useState(true);

  const [isFormResponse, setIsFormResponse] = useState(false);

  const [isProgrammeRequired, setIsProgrammeRequired] = useState(false);
  const [isProgrammeGroupRequired, setIsProgrammeGroupRequired] =
    useState(false);
  const [isGSTRequired, setIsGSTRequired] = useState(false);

  const [formResponseMessage, setFormResponseMessage] = useState("");
  const [formResponseStatus, setFormResponseStatus] = useState("");

  const [accountList, setAccountList] = useState([]);
  const [programmeList, setProgrammeList] = useState([]);
  const [programmeGroupList, setProgrammeGroupList] = useState([]);

  const [cgstList, setCgstList] = useState([]);
  const [sgstList, setSgstList] = useState([]);
  const [igstList, setIgstList] = useState([]);

  const [isSecurityDepositDisable, setIsSecurityDepositDisable] =
    useState(false);
  const [noOfMonthEnable, setnoOfMonthEnable] = useState(false);

  //added by anil on 28-03-2024
  const showTotal = (total, range) =>
    `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);
  const pageSizeOptions = ["10", "20", "30", "50", "100"];
  const [isMonthlyLoaderEnable, setIsMonthlyLoaderEnable] = useState(false);
  const [filteredSearchList, setFilteredSearchList] = useState([]);
  const [monthalyfeesListList, setMonthalyfeesList] = useState([]);
 
  const [formDefaultValues, setFormDefaultValues] = useState({
    
    component_id: data.component_id,
    mode: data.mode,
    description: data.description,
    amount: data.amount,
    programme_id:
      commonUtility.sanitizeValue(data.programme_id) > 0
        ? data.programme_id
        : "",
    group_id:
      commonUtility.sanitizeValue(data.group_id) > 0 ? data.group_id : "",
    account_id: data.account_id,
    is_gst_applicable: data.is_gst_applicable,
    is_reg_component: data.is_reg_component,
    component_type: data.component_type,
    cgst_id: data.cgst_id,
    sgst_id: data.sgst_id,
    hsn_code: data.hsn_code,
    is_security: data.is_security,
    is_active: data.is_active,
    for_month: data.for_month,
    rate_for: data.rate_for,
  });

  const [mode, setMode] = useState(data.mode);
  const [form] = Form.useForm();
  const [monthlyForm] = Form.useForm();

  const onProgrammeCommercialSave = async (values) => {
    setIsLoaderEnable(true);
    //   console.log(values);
    const data = { formdata: values };
    const response = ProgrammeCommercialService.save(data).then((resdata) => {
      setIsFormResponse(true);
      setFormResponseStatus(resdata.response_status);
      setFormResponseMessage(resdata.response_msg);
      setIsLoaderEnable(false);

      const x = {
        component_id: commonUtility.randomID(),
        description: values.description,
      };
      dispatch(addProgrammeCommercial(x));
    });
  };

  const onSelectComponentType = (value, event) => {
    form.setFieldsValue({
      programme_id: "",
      group_id: "",
    });
    if (value == "ADMISSION") {
      setIsProgrammeRequired(true);
      setIsProgrammeGroupRequired(true);
      setIsSecurityDepositDisable(false);
    } else if (value == "MONTHLY") {
      setIsProgrammeRequired(true);
      setIsProgrammeGroupRequired(true);
      setIsSecurityDepositDisable(true);
      form.setFieldsValue({
        is_security: "N",
      });
    } else {
      form.setFieldsValue({
        programme_id: "",
        group_id: "",
        is_security: "N",
      });
      setIsProgrammeRequired(false);
      setIsProgrammeGroupRequired(false);
      setIsSecurityDepositDisable(true);
    }
  };

  const onChangeProgramme = (e, obj) => {
    // console.log('e',e);
    // console.log('obj',obj.short_code);
    setnoOfMonthEnable(false);
    setIsProgrammeGroupRequired(true);
    form.setFieldsValue({
      for_month: "",
      amount: "",
      group_id: "",
    });
    if (obj.short_code == "HP" || obj.short_code == "JHP") {
      setIsProgrammeGroupRequired(false);
    }
    if (obj.short_code == "GYM") {
      setIsProgrammeGroupRequired(false);
      setnoOfMonthEnable(true);
    }

    if (form.getFieldValue("is_security") == "Y") {
      setIsProgrammeGroupRequired(false);
    }
  };

  const hideResponseMessage = () => {
    setIsFormResponse(false);
    if (mode == "ADD") {
      form.resetFields();
      form.setFieldsValue({
        component_id: formDefaultValues.component_id,
        mode: formDefaultValues.mode,
        is_gst_applicable: "N",
        is_active: "Y",
      });

      setIsProgrammeGroupRequired(true);
    }
  };

  const onChangeGstApplicable = (e) => {
    form.setFieldsValue({
      cgst_id: "",
      sgst_id: "",
    });
    if (e.target.value == "Y") {
      setIsGSTRequired(true);
    } else {
      setIsGSTRequired(false);
    }
  };

  const onChangeSecurityDeposite = (e) => {
    form.setFieldsValue({
      group_id: "",
    });
    if (e.target.value == "Y") {
      setIsProgrammeRequired(true);
      setIsProgrammeGroupRequired(false);
    } else {
      setIsProgrammeRequired(true);
      setIsProgrammeGroupRequired(true);
    }
  };

  useEffect(() => {
    // setFormDefaultValues({
    //     component_id: data.component_id,
    //     mode: data.mode,
    //     description: data.description,
    //     amount: data.amount,
    //     programme_id: data.programme_id,
    //     account_id: data.account_id,
    //     is_gst_applicable: data.is_gst_applicable,
    //     is_reg_component: data.is_reg_component
    //   })

    //console.log(mode)

    mode == EDIT_MODE
      ? form.setFieldsValue({
          component_id: formDefaultValues.component_id,
          mode: formDefaultValues.mode,
          description: formDefaultValues.description,
          amount: formDefaultValues.amount,
          programme_id:
            commonUtility.sanitizeValue(formDefaultValues.programme_id) > 0
              ? formDefaultValues.programme_id
              : "",
          group_id:
            commonUtility.sanitizeValue(formDefaultValues.group_id) > 0
              ? formDefaultValues.group_id
              : "",
          account_id: formDefaultValues.account_id,
          is_gst_applicable: formDefaultValues.is_gst_applicable,
          is_reg_component: formDefaultValues.is_reg_component,
          component_type: formDefaultValues.component_type,
          cgst_id: formDefaultValues.cgst_id,
          sgst_id: formDefaultValues.sgst_id,
          hsn_code: formDefaultValues.hsn_code,
          is_security: formDefaultValues.is_security,
          is_active: formDefaultValues.is_active,
          for_month: formDefaultValues.for_month,
          rate_for: formDefaultValues.rate_for,
        })
      : form.setFieldsValue({
          /*
                component_id: 0,
                mode: data.mode,
                description: "",
                amount: "",
                programme_id: 0,
                group_id: 0,
                account_id: 0,
                is_gst_applicable: "",
                is_reg_component: "",
                component_type: "",
                is_active: data.is_active,
                */

          component_id: "",
          description: "",
          programme_id: "",
          group_id: "",
          programme_name: "",
          account_name: "",
          account_id: "",
          amount: "",
          is_gst_applicable: "N",
          is_reg_component: "",
          component_type: "",
          cgst_id: "",
          sgst_id: "",
          mode: data.mode,
          hsn_code: "",
          is_security: "N",
          is_active: "Y",
          for_month: "",
          rate_for: "MEMBER",
        });

    form.setFieldsValue(formDefaultValues);
    const allowedProgrammeIds = [1,3,4,6];
    (mode == EDIT_MODE && formDefaultValues.component_type == "MONTHLY" && allowedProgrammeIds.includes(formDefaultValues.programme_id)) ? setIsMonthlyGenerate(false) : setIsMonthlyGenerate(true)
    if (form.getFieldValue("is_gst_applicable") == "Y") {
      setIsGSTRequired(true);
    }

    // if(form.getFieldValue('is_security') == "Y") {
    //     setIsProgrammeRequired(true);
    //     setIsProgrammeGroupRequired(false);
    //     setIsSecurityDepositDisable(false);
    // }
    // else{
    //     setIsProgrammeRequired(true);
    //     setIsProgrammeGroupRequired(true);
    //     setIsSecurityDepositDisable(true);
    // }

    if (form.getFieldValue("component_type") != "OTHERS") {
      setIsProgrammeRequired(true);
      setIsProgrammeGroupRequired(true);

      if (form.getFieldValue("is_security") == "Y") {
        setIsProgrammeRequired(true);
        setIsProgrammeGroupRequired(false);
        setIsSecurityDepositDisable(false);
      } else {
        setIsProgrammeRequired(true);
        setIsProgrammeGroupRequired(true);
        setIsSecurityDepositDisable(true);
      }
    } else {
      setIsProgrammeRequired(false);
      setIsProgrammeGroupRequired(false);
      setIsSecurityDepositDisable(true);
    }

    if (form.getFieldValue("programme_id") == GYM_PROGRAM_ID) {
      setnoOfMonthEnable(true);
      setIsProgrammeGroupRequired(false);
    } else if (form.getFieldValue("programme_id") == HP_PROGRAM_ID || form.getFieldValue("programme_id") == JHP_PROGRAM_ID) {
      setnoOfMonthEnable(false);
      setIsProgrammeGroupRequired(false);
    } else {
      setnoOfMonthEnable(false);
    }
  }, [form]);

  useEffect(() => {
    accountService.accountList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setAccountList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    ProgrammeService.programmeList().then((res) => {
      console.log(res);
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    ProgrammeService.programmeGroupList().then((res) => {
      console.log(res.data.response_data);
      setProgrammeGroupList(res.data.response_data);
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: { gstType: "CGST", usedfor: "O" },
    };
    accountService.gstListByInputType(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setCgstList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: { gstType: "SGST", usedfor: "O" },
    };
    accountService.gstListByInputType(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSgstList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: { gstType: "IGST", usedfor: "O" },
    };
    accountService.gstListByInputType(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setIgstList(res.data.response_data);
      }
    });
  }, []);

  // added by anil on 28-03-2024

  const [loadingItems, setLoadingItems] = useState({});

  const handleAmountChange = (value, record) => {
    commonUtility.allowOnlyNumber(value);
    setIsFormResponse(false);
    // if(commonUtility.allowOnlyNumber(value) != ""){

    // }
    setMonthalyfeesList((prevData) => {
      const newData = [...prevData];
      const index = newData.findIndex(
        (item) => item.monthly_details_id === record.monthly_details_id
      );
      newData[index].amount = commonUtility.allowOnlyNumber(value);
      newData[index].isSaved = false;
      return newData;
    });
  };

  const monthlyFessUpdate = (values) => {
    // console.log(values);
    setIsFormResponse(false);
    setLoadingItems(prevLoadingItems => ({
        ...prevLoadingItems,
        [values.monthly_details_id]: true
      }));

    const formdValues = {
      monthly_details_id: values.monthly_details_id,
      amount: values.amount,
    };
    const data = { formdata: formdValues };
    ProgrammeCommercialService.monthlyFessUpdate(data).then((res) => {
      //   console.log('res.data.response_status',res.data.response_status);
      if (res.data.response_status == SUCCESS_STATUS) {
        setMonthalyfeesList((prevData) => {

          setIsFormResponse(true);
          setFormResponseStatus(res.data.response_status);
          setFormResponseMessage(res.data.response_msg);

          const newData = [...prevData];
          const index = newData.findIndex(
            (item) => item.monthly_details_id === values.monthly_details_id
          );
          newData[index].isSaved = true;
          return newData;
        });
       
      } else {
        
      }

      setLoadingItems(prevLoadingItems => ({
        ...prevLoadingItems,
        [values.monthly_details_id]: false
      }));
      
      // setIsDataUpdated(!isDataUpdated)
    });
  };

  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "index",
    //   render: (text, record, index) => index + 1,
    //   width: "5%",
    // },
    {
      title: "Month",
      dataIndex: "short_name",
      sorter: (a, b) => a.short_name.localeCompare(b.short_name),
      render: (text, record) => (
        <span>{`${record.short_name} - ${record.year}`}</span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (text, record) => (
        <Input
          style={{ width: "100px", borderRadius: "8px" }}
          value={text}
          onChange={(e) => handleAmountChange(e.target.value, record)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (selectedObj) => (
        <Space size="middle">
          {loadingItems[selectedObj.monthly_details_id] ? (
            <Spin />
          ) : (
            <>
              <Button
                htmlType="button"
                type="ghost"
                size="small"
                shape="round"
                className="custom-button-green"
                onClick={() => monthlyFessUpdate(selectedObj)}
              >
                Update <RightOutlined />
              </Button>
            </>
          )}
        </Space>
      ),
    },
  ];

  const genrateMonthlyHead = async (values) => {
    setIsMonthlyLoaderEnable(true);
    //   console.log(form.getFieldValue('component_id'));
    //   console.log(values);
    const data = {
      formdata: {
        total_month: parseInt(values.no_of_month),
        component_id: form.getFieldValue('component_id'),
        amount: parseFloat(values.monthly_amount),
      },
    };
    // console.log(data);
    const response = ProgrammeCommercialService.generateMonthlyFees(data).then(
      (resdata) => {
        monthlyForm.resetFields(['no_of_month', 'monthly_amount']);
        setIsMonthlyLoaderEnable(false);
        updateMonthlyFeesList();       
      }
    );
  };

  const updateMonthlyFeesList = () => {
    const data = { formdata: { component_id: formDefaultValues.component_id } };
    ProgrammeCommercialService.monthlyFeesdetailComponent(data).then((res) => {
      setMonthalyfeesList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  };

  useEffect(() => {
    updateMonthlyFeesList(); // Fetch data initially
  }, []);

  return (
    <div>
      <div className="form-input-style">
        <Row className="" style={{ background: "transparent" }}>
          <Col className="" xs={24} xl={24}>
            <Form
              form={form}
              layout="vertical"
              onFinish={onProgrammeCommercialSave}
              autoComplete="off"
              // initialValues={formDefaultValues}
            >
              {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
              <Row gutter={20}>
                <Col className="gutter-row" xs={24} xl={24}>
                  <Form.Item
                    name="description"
                    label="Description"
                    rules={[
                      {
                        required: true,
                        message: "Description is required",
                      },
                    ]}
                  >
                    <Input placeholder="" size="large" />
                  </Form.Item>
                  <Form.Item
                    name="component_id"
                    label="component_id"
                    hidden={true}
                  >
                    <Input type="text" />
                  </Form.Item>
                  <Form.Item name="mode" label="mode" hidden={true}>
                    <Input type="text" />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item
                    name="component_type"
                    label="Component Type"
                    rules={[
                      {
                        required: true,
                        message: "Component type is required",
                      },
                    ]}
                  >
                    <Select
                      className="text-left"
                      defaultValue="Select"
                      onSelect={(value, event) =>
                        onSelectComponentType(value, event)
                      }
                    >
                      <Option value="">Select</Option>
                      <Option key="ADMISSION" value="ADMISSION">
                        Admission
                      </Option>
                      <Option key="MONTHLY" value="MONTHLY">
                        Monthly
                      </Option>
                      <Option key="OTHERS" value="OTHERS">
                        Others
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item name="is_security" label="Is Security Deposit">
                    <Radio.Group
                      defaultValue="N"
                      style={{ width: "100%" }}
                      optionType="button"
                      buttonStyle="solid"
                      onChange={onChangeSecurityDeposite}
                      disabled={isSecurityDepositDisable}
                    >
                      <Radio.Button value="Y">Yes</Radio.Button>
                      <Radio.Button value="N">No</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item
                    name="programme_id"
                    label="Programme"
                    rules={[
                      {
                        required: isProgrammeRequired,
                        message: "Programme is required",
                      },
                    ]}
                  >
                    <Select
                      className="text-left"
                      disabled={!isProgrammeRequired}
                      onSelect={(value, event) =>
                        onChangeProgramme(value, event)
                      }
                    >
                      <Option value="">Select</Option>
                      {programmeList.length > 0
                        ? programmeList.map((programme_data) => (
                            <Option
                              key={programme_data.programme_id}
                              value={programme_data.programme_id}
                              short_code={programme_data.short_code}
                            >
                              {programme_data.programme_name}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item name="rate_for" label="Member / Non Member">
                    <Select className="text-left" defaultValue="Select">
                      <Option key="MEMBER" value="MEMBER">
                        Member
                      </Option>
                      <Option key="NON-MEMBER" value="NON-MEMBER">
                        Non-Member
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item
                    name="group_id"
                    label="Programme Group (Shift) "
                    rules={[
                      {
                        required: isProgrammeGroupRequired,
                        message: "Programme Group is required",
                      },
                    ]}
                  >
                    <Select
                      className="text-left"
                      disabled={!isProgrammeGroupRequired}
                    >
                      <Option value="">Select</Option>
                      {programmeGroupList.length > 0
                        ? programmeGroupList.map((programme_group_data) => (
                            <Option
                              key={programme_group_data.programme_group_id}
                              value={programme_group_data.programme_group_id}
                              short_code={programme_group_data.short_code}
                            >
                              {programme_group_data.programme_group}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={6}>
                  <Form.Item
                    name="for_month"
                    label="No. Of Month"
                    rules={[
                      {
                        required: noOfMonthEnable,
                        message: "Enter no of month",
                      },
                    ]}
                  >
                    <Input placeholder="" disabled={!noOfMonthEnable} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={6}>
                  <Form.Item
                    name="amount"
                    label="Amount"
                    rules={[
                      {
                        required: true,
                        message: "Amount is required",
                      },
                    ]}
                  >
                    <Input placeholder="" />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={24}>
                  <Form.Item
                    name="account_id"
                    label="Account"
                    rules={[
                      {
                        required: true,
                        message: "Account is required",
                      },
                    ]}
                  >
                    {/* <Select className="text-left" defaultValue="0"> */}

                    <Select
                      showSearch
                      placeholder="Search to Select"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        // option.children.includes(input)
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase())
                      }
                      placement="bottomLeft"
                      allowClear={true}
                    >
                      {accountList.length > 0
                        ? accountList.map((account_data) => (
                            <Option
                              key={account_data.id}
                              value={account_data.id}
                            >
                              {account_data.account_name}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item name="hsn_code" label="HSN Code">
                    <Input placeholder="" />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={8}>
                  <Form.Item name="is_gst_applicable" label="GST Applicable">
                    <Radio.Group
                      defaultValue="Y"
                      style={{ width: "100%" }}
                      optionType="button"
                      buttonStyle="solid"
                      onChange={onChangeGstApplicable}
                    >
                      <Radio.Button value="Y">Yes</Radio.Button>
                      <Radio.Button value="N">No</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item
                    name="cgst_id"
                    rules={[
                      { required: isGSTRequired, message: "CGST Required" },
                    ]}
                    label="CGST"
                    hidden={!isGSTRequired}
                  >
                    <Select
                      className="text-left"
                      defaultValue="Select"
                      // onSelect={(value, event) => onSelectCGST(event,"DROPDOWN",0,0)}
                    >
                      <Option value="">Select</Option>
                      {cgstList.length > 0
                        ? cgstList.map((cgst_list) => (
                            <Option
                              key={cgst_list.id}
                              value={cgst_list.id}
                              rate={cgst_list.rate}
                            >
                              {cgst_list.gstDescription}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item
                    name="sgst_id"
                    rules={[
                      { required: isGSTRequired, message: "SGST Required" },
                    ]}
                    label="SGST"
                    hidden={!isGSTRequired}
                  >
                    <Select
                      className="text-left"
                      defaultValue="Select"
                      // onSelect={(value, event) => onSelectCGST(event,"DROPDOWN",0,0)}
                    >
                      <Option value="">Select</Option>
                      {sgstList.length > 0
                        ? sgstList.map((sgst_list) => (
                            <Option
                              key={sgst_list.id}
                              value={sgst_list.id}
                              rate={sgst_list.rate}
                            >
                              {sgst_list.gstDescription}
                            </Option>
                          ))
                        : ""}
                    </Select>
                  </Form.Item>
                </Col>

                {/*
                                <Col xs={24} xl={12}>
                                    <Form.Item
                                        name="igst_id"
                                        rules={[{ required: true, message: "" }]}
                                        label="IGST"
                                    >
                                        <Select
                                            className="text-left"
                                            defaultValue="Select"
                                        >
                                            {igstList.length > 0
                                                ? igstList.map((igst_list) => (
                                                    <Option
                                                        key={igst_list.id}
                                                        value={igst_list.id}
                                                        rate={igst_list.rate}
                                                    >
                                                        {igst_list.gstDescription}
                                                    </Option>
                                                ))
                                                : ""}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                */}

                <Col xs={24} xl={12}>
                  <Form.Item name="is_active" label="Active">
                    <Radio.Group
                      defaultValue="Y"
                      style={{ width: "100%" }}
                      optionType="button"
                      buttonStyle="solid"
                    >
                      <Radio.Button value="Y">Yes</Radio.Button>
                      <Radio.Button value="N">No</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item name="" label=" ">
                    <Space>
                      {isLoaderEnable ? (
                        <Spin />
                      ) : (
                        <>
                          <Button
                            className="custom-button-green"
                            htmlType="submit"
                          >
                            Save <RightOutlined />
                          </Button>
                        </>
                      )}
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Divider />
            <Form
              form={monthlyForm}
              layout="vertical"
              onFinish={genrateMonthlyHead}
              autoComplete="off"
              hidden={isMonthlyGenerate}
            >
              <Row gutter={20}>
                <Col xs={24} xl={8}>
                  <Form.Item
                    name="no_of_month"
                    label="No Of Month"
                    rules={[
                      {
                        required: true,
                        message: "Enter number of months",
                      },
                      {
                        pattern: /^[0-9]*$/, // Regular expression to allow only numbers
                        message: "Please enter valid numbers only",
                      },
                    ]}
                  >
                    <Input placeholder="" />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={8}>
                  <Form.Item
                    name="monthly_amount"
                    label="Amount"
                    rules={[
                      {
                        required: true,
                        message: "Enter amount",
                      },
                      {
                        pattern: /^\d+(\.\d{1,2})?$/, // Regular expression to allow only amounts with two decimal points
                        message: "Enter a valid amount",
                      },
                    ]}
                  >
                    <Input placeholder="" />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={8}>
                  <Form.Item name="" label=" ">
                    <Space>
                      {isMonthlyLoaderEnable ? (
                        <Spin />
                      ) : (
                        <>
                          <Button
                            className="custom-button-green"
                            htmlType="submit"
                          >
                            Save <RightOutlined />
                          </Button>
                        </>
                      )}
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        {
          // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
          isFormResponse ? (
            <CustomMessage
              title={formResponseStatus}
              subtitle={formResponseMessage}
              action={hideResponseMessage}
              onDrawerClose={onDrawerClose}
              mode={form.getFieldValue("mode")}
            />
          ) : (
            ""
          )
        }
         <Divider />
        {/* <CustomTableSearch onSearchTable={onSearch} /> */}
        {!isMonthlyGenerate && (
        <Table        
          columns={columns}
          rowKey="monthly_details_id"
          //dataSource={programmecomponentList}
          dataSource={filteredSearchList}
          // pagination={{
          //     pageSizeOptions: pageSizeOptions,
          //     showSizeChanger: true,
          //     defaultPageSize: parseInt(pageSizeOptions[0], 10), // Set the initial page length
          //     showTotal,
          //     onChange(current) {
          //     setPage(current);
          //     }
          // }}
          size="small"
         
        />
        )}
      </div>
    </div>
  );
};

export default ProgrammComercialEntry;
